import { CheckoutState } from '../../state';
import { shouldDisplayAttendeeBasicInfoQuestionsAfterPayment } from '../../utils/statsig';
import {
    getIsPaymentView,
    isOrganizerQuestionsPage,
    isPreTicketsOrganizerQuestionsPage,
} from '../routing';

export const shouldPrefillFirstAttendeeBasicInfoQuestions = (
    state: CheckoutState,
) =>
    (getIsPaymentView(state) &&
        !shouldDisplayAttendeeBasicInfoQuestionsAfterPayment()) ||
    ((isOrganizerQuestionsPage(state) ||
        isPreTicketsOrganizerQuestionsPage(state)) &&
        shouldDisplayAttendeeBasicInfoQuestionsAfterPayment());
